"use strict";

exports.__esModule = true;
exports.xMidasInit = xMidasInit;
exports.xMidasEncrypt = xMidasEncrypt;

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.match.js");

require("core-js/modules/es.array.join.js");

var _mapValues = _interopRequireDefault(require("@tencent/midas-libs/dist/lib/map-values"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 注：目前在 common_logic.html 里面也写了一份相同的逻辑，后面可以统一使用本文件
function monitorTime(fn) {
  var start = Date.now();
  var result = fn();
  var ellapsed = Date.now() - start;
  return {
    times: ellapsed,
    result: result
  };
}

function hexToBase64(str) {
  return btoa(String.fromCharCode.apply(String, str.match(/../g).map(function (x) {
    return parseInt(x, 16);
  })));
} // 兼容活动和官网的上报


var report = function report(iformat, resultinfo) {
  var _ref = window,
      report = _ref.report; // 活动的上报，位于 commonLogic.js

  if (typeof report === 'function') {
    return report("midasbuy.custom." + iformat, resultinfo);
  } // 官网的上报


  if (typeof report === 'object' && typeof report.custom === 'function') {
    return report.custom(iformat, resultinfo);
  }

  return null;
};

function xMidasInit() {
  var encryptedKey = document.getElementById('xMidasToken').value;

  if (!encryptedKey) {
    report('xmidas.no.token');
    return;
  }

  try {
    var initResult = monitorTime(function () {
      return (// xMidas 不传参数，使用 #xMidasToken 初始化
        window.xMidas()
      );
    });
    var checkResult = initResult.result || [];
    report('xmidas.init', {
      times: initResult.times
    });

    if (checkResult.length > 0) {
      report('xmidas.init.result', {
        result: checkResult.join(',')
      });
    }
  } catch (_) {}
}

function xMidasEncrypt(params) {
  var _document$getElementB, _document$getElementB2;

  var aesMsg = JSON.stringify((0, _mapValues.default)(params, function (v) {
    return typeof v !== 'undefined' && typeof v !== 'object' ? String(v) : v;
  }));
  var encryptedKey = (_document$getElementB = document.getElementById('xMidasToken')) == null ? void 0 : _document$getElementB.value;
  if (!encryptedKey) return params;
  var baseKeyVersion = (_document$getElementB2 = document.getElementById('xMidasVersion')) == null ? void 0 : _document$getElementB2.value;
  var encryptData = monitorTime(function () {
    try {
      return window.xMidas({
        d: aesMsg
      });
    } catch (_) {
      return params;
    }
  });

  if (!encryptData.result) {
    report('xmidas.error', {
      times: encryptData.times
    });
    return params;
  }

  report('xmidas.encrypt', {
    times: encryptData.times
  });
  return {
    encrypt_msg: hexToBase64(encryptData.result),
    ctoken_ver: baseKeyVersion,
    ctoken: encryptedKey
  };
}